/* @flow */

import { Store } from "shared/src/stores/Store";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import DepotSettingsClient from "../clients/DepotSettingsClient";
import StoreAction from "../actions/StoreAction";
import TrackingUtil from "shared/src/utils/TrackingUtil";
import { StoreType } from "../datatypes/Store";
import { trackCustomerChangeStore } from "../utils/UserTrackingUtil";
import { isEmpty } from "shared/src/utils/util";

type State = {
    requestedStore: string | undefined | null;
    currentStore: StoreType | undefined | null;
    isLoading: boolean;
};

let state: State;

/**
 * Reads selected customer store from SessionStore.
 */
class StoreDataStore extends Store {
    constructor() {
        super();
        state = this.getEmptyState();
        this.listenTo(SessionStore, this.loadStoreData);
        this.listenTo(StoreAction.storeSelected, this.onGetStoreSuccess as any); // FIXME
        this.loadStoreData();
    }

    getEmptyState(): State {
        return {
            requestedStore: null,
            currentStore: null,
            isLoading: false
        };
    }

    loadStoreData() {
        if (SessionStore.pending()) {
            return;
        }
        const selectedStoreId = SessionStore.getCustomerStore() || SessionStore.getSelectedStoreId();
        // FIXME: Do we still need this store if we've got the MetroStoresStore?
        if (
            (state.isLoading && selectedStoreId === state.requestedStore) ||
            isEmpty(selectedStoreId) ||
            selectedStoreId === state.currentStore?.storeId?.locationNumber
        ) {
            return;
        }
        state.isLoading = true;
        state.requestedStore = selectedStoreId;
        DepotSettingsClient.getStoreInformation(selectedStoreId, SessionStore.getCountry())
            .then((response: StoreType) => this.onGetStoreSuccess(response))
            .catch((e) => {
                state.isLoading = false;
                const sessionStoreState = SessionStore.getState();
                TrackingUtil.trackUiErrorSd("StoreDataStore", "Fetching store data failed: ", e, {
                    state: sessionStoreState
                });
            });
    }

    getCurrentStore(): StoreType | undefined | null {
        return state.currentStore;
    }

    getCurrentStoreName(): string | undefined | null {
        return state.currentStore ? state.currentStore.storeDisplayName : null;
    }

    onGetStoreSuccess(storeData: StoreType) {
        if (state.requestedStore !== storeData.storeId.locationNumber) {
            return;
        }

        if (!state.currentStore || storeData.storeId.fullId !== state.currentStore.storeId.fullId) {
            const printName = storeData?.printoutInformation?.printName;
            const storeName = printName ? printName : storeData.storeName;
            trackCustomerChangeStore(storeName, storeData.storeId.locationNumber);
        }

        state.isLoading = false;
        state.currentStore = storeData;
        const printName = storeData?.printoutInformation?.printName;
        if (state.currentStore) {
            state.currentStore.storeDisplayName = printName || storeData.storeName;
        }
        this.trigger(state.currentStore);
    }

    // For testing
    resetState() {
        state = this.getEmptyState();
    }
}

export default new StoreDataStore();
